import { useUserSettings } from '../useUserSettings'

interface UseFormatContext {
  formatDate: (date?: number | Date | undefined) => string
  formatUnit: (value: number | bigint) => string
}

interface UseFormatParams {
  dateOptions?: Intl.DateTimeFormatOptions
  unit?: 'year' | 'month' | 'day' | 'hour' | 'minute'
}

const defaultTimeZone = 'America/Denver'

const useFormat = ({ dateOptions, unit = 'minute' }: UseFormatParams): UseFormatContext => {
  const { locale } = useUserSettings()
  const { timeZone, ...rest } = dateOptions ?? {}

  const formatDate = Intl.DateTimeFormat(locale, { ...rest, timeZone: timeZone || defaultTimeZone }).format
  const formatUnit = Intl.NumberFormat(locale, { style: 'unit', unit }).format

  return {
    formatDate,
    formatUnit,
  }
}

export { useFormat }
